import React, { useMemo } from 'react';
import { Translate } from 'react-localize-redux';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useOutletContext } from 'react-router-dom';
import surveyStyles from '../survey.module.css';
import TranslatedHTMLText from '../../TranslatedHTMLText';
import SurveyProgressBar from '../SurveyProgressBar';
import { getCompiledPath, getSurveySchemaPartAmount, hasQuestionType } from '../../../util';
import { routes } from '../../../constants';
import Notification from '../../Notification';
import { withLang, langType } from '../../../i18n';
import { questionTypeValues } from '../../../constants/types';

const Introduction = ({ translate: t }) => {
  const [setCurrentPage, setPageCount] = useOutletContext();
  const survey = useSelector(((state) => state.survey.surveyContent), {
    equalityFn: shallowEqual
  });
  const {
    introduction, id, researchConsentNeeded, surveySchemaParts, extraSurveyPart
  } = survey;

  const showSensitiveDataNotification = useMemo(() => {
    const parts = extraSurveyPart
      ? [...surveySchemaParts, extraSurveyPart]
      : surveySchemaParts;
    return hasQuestionType(parts, questionTypeValues.TEXT_FIELD);
  }, [surveySchemaParts, extraSurveyPart]);

  return (
    <section>
      <SurveyProgressBar
        current={0}
        total={getSurveySchemaPartAmount(survey)}
        researchConsentNeeded={researchConsentNeeded}
        setCurrentPage={setCurrentPage}
        setPageCount={setPageCount}
      />
      {/* WARNING: UH-670 - This might not be accessible if the html is not formatted correctly */}
      {introduction
        ? <TranslatedHTMLText html={introduction} /> : null}
      {showSensitiveDataNotification
        ? <Notification text={t('survey.sensitiveInfoNotification')} /> : null}
      <nav className={surveyStyles.navigation}>
        <Link
          className={`${surveyStyles.navButton} button--action icon--arrow-right`}
          to={getCompiledPath(routes.survey.surveyPart, { surveyId: id, page: 1 })}
          data-cy="survey-continue-button"
        >
          <Translate id="common.continue" />
        </Link>
      </nav>
    </section>
  );
};

Introduction.propTypes = {
  ...langType
};

export default withLang(Introduction);
